/* eslint-disable react-hooks/exhaustive-deps */
import SignUp from "./signintest"
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from "react";
import { getENVData } from "../../constants/constantValue";
import axios, { AxiosRequestConfig } from "axios";
import Helper from '../../Helper';

const ProfilePage = () => {
    const ENV = getENVData()
    const { isAuthenticated, user } = useAuth0();
    const ApiCall = (token: string) => {
        var options: AxiosRequestConfig = {
            method: 'GET',
            url: `${ENV.base_api}/auth0/user`,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        };
        axios(options).then(function (response) {
            if (response?.data?.logins_count === 1 && response?.data.hasOwnProperty('last_password_reset') === false) {
                ChangePassword(token)
            }
        }).catch(function (error) {
            console.error(error);
        });
    }

    const ChangePassword = async (tok: string) => {
        var options: AxiosRequestConfig = {
            method: 'POST',
            url: `${ENV.base_api}/auth0/tickets/password-change`,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${tok}`
            },
            data: {
                user_id: user?.sub,
                result_url: window.location.href
            }
        };

        await axios(options).then(function (response) {
            window.location.href = response?.data?.ticket
        }).catch(function (error) {
            console.error(error);
        });
    }

    useEffect(() => {
        if (isAuthenticated && user?.sub) {
            axios(`${ENV.base_api}/token`, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Auth-Token': `${Helper.token}`
                }
            }).then(node => {
                ApiCall(node.data.token);
            }).catch(ex => {
                console.error(ex);
            });
        }
    }, [user])

    return <SignUp />
}

export default ProfilePage